// extracted by mini-css-extract-plugin
export var button = "_z-0";
export var buttonContent = "_z-e";
export var buttonGroup = "_z-c";
export var dontRestrainIconWidth = "_z-a";
export var dropdownButton = "_z-b";
export var iconContainer = "_z-9";
export var lg = "_z-4";
export var md = "_z-3";
export var pending = "_z-f";
export var sm = "_z-2";
export var spinner = "_z-d";
export var squared = "_z-8";
export var wrapText = "_z-g";
export var xl = "_z-5";
export var xs = "_z-1";
export var xxl = "_z-6";
export var xxxl = "_z-7";